import ApiClient from './apiClient'
import {
  ResponseHeaderInformation,
} from '../types/information'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getInformation = async (): Promise<any> => ApiClient.get(
  '/api/common/header_information',
  (result: ResponseHeaderInformation) => result,
)

export default getInformation
